import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const InstanceGroupPermissionGate = (props: Omit<BasePermissionGateProps<"instance">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="instance"
		/>
	)
}

export default InstanceGroupPermissionGate
